import { Component, OnInit } from '@angular/core'
import { ProductDetailService } from '../../../services/product-detail.service'

@Component({
  selector: 'app-product-packing',
  templateUrl: './product-packing.component.html',
  styleUrls: ['./product-packing.component.scss'],
})
export class ProductPackingComponent implements OnInit {
  countByOptions = ['by-piece', 'by-pack']
  selectedCountBy = 'by-piece'

  constructor(public productDetailService: ProductDetailService) {}

  ngOnInit() {
    this.selectedCountBy = this.productDetailService.isCountByPiece ? 'by-piece' : 'by-pack'
  }

  selectedCountByChanged($event: any) {
    this.selectedCountBy = $event
    this.productDetailService.isCountByPiece = $event === 'by-piece'
    if (this.selectedCountBy === 'by-pack') {
      this.productDetailService.product.tags = []
    } else {
      this.productDetailService.product.tags = this.productDetailService.tags.filter(
        tag => tag.externalId === 'hs-count-by-piece',
      )
    }
  }
}
